import request from "@/lib/Request";

/**
 * 取得暱稱
 * @param {*} params 
 * @returns 
 */
export function nickName() {
  return request({
    url: "/me",
    method: "get"
  });
}
